import { render } from "./Spacer.vue?vue&type=template&id=428181de&scoped=true"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"

import "./Spacer.vue?vue&type=style&index=0&id=428181de&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428181de"]])

export default __exports__